import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const errorMessageStyles = css`
  font-size: 14px;
  color: var(--color-error-600);
  padding: var(--spacing-2);
  background-color: var(--color-error-50);
  border-radius: var(--radius-sm);
`;

export const PaymentForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
`;
